export const facebook = "https://www.facebook.com/icwomenincomputing"
export const twitter = "https://twitter.com/wic_imperial"
export const instagram = "https://www.instagram.com/wic_imperial/"
export const mailingList = "http://eepurl.com/hpvHoT"
